import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseApi, getErrorMessage } from '@/shared/api';
import type { SharedPreset } from '../model/types';
import type { SharedPresetDTO } from './types';

export const api = createApi({
  reducerPath: 'sharedPresetsAPI',
  baseQuery: fakeBaseQuery(),
  endpoints: (builder) => ({
    getSharedPreset: builder.query({
      queryFn: async (id: string) => {
        const { data, error } = await baseApi.functions.invoke<{
          sharedPreset: SharedPresetDTO;
        }>(`shared-presets/${id}`, {
          method: 'GET',
        });

        if (!data) {
          return { error: new Error(getErrorMessage(error)) };
        }

        return {
          data: {
            ...(data.sharedPreset.preset as SharedPreset),
            organizationId: data.sharedPreset.organizationId,
          },
        };
      },
    }),
    createSharedPreset: builder.mutation<string, { preset: SharedPreset }>({
      queryFn: async ({ preset }) => {
        const { data, error } = await baseApi.functions.invoke<{
          sharedPreset: SharedPresetDTO;
        }>('shared-presets', {
          method: 'POST',
          body: {
            preset,
          },
        });

        if (!data) {
          return { error: new Error(getErrorMessage(error)) };
        }

        return { data: data.sharedPreset.id };
      },
    }),
  }),
});

export const {
  useGetSharedPresetQuery,
  useCreateSharedPresetMutation,
  middleware,
} = api;
